import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 250,
    height: '32px',
    marginTop: '9px',
    borderRadius: '16px'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function CustomizedInputBase(props) {
  const classes = useStyles();

  return (
    <Paper className={classes.root} style={props.width ? { width: props.width } : {}}>
      <InputBase
        className={classes.input}
        onKeyPress={(e) => {
          var code = (e.keyCode ? e.keyCode : e.which);
          if (code == 13) { //Enter keycode
            props.handleSubmit()
          }
        }}
        onChange={props.onChange}
        placeholder={props.title ? props.title : "Search In Grospick"}
        inputProps={{ 'aria-label': 'search google maps' }}
      />
      <IconButton type="button" onClick={props.handleSubmit} className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}